export const EVERYONE_SENTINEL = "_";
export const COLLABORATOR_SENTINEL = "__COLLABORATOR__";
export const DEFAULT_REGION = "_default";
export const NEW_REFERRAL_SENTINEL = "__newreferral";
export const EMPTY_REFERRAL_SENTINEL = "__none";
export const GENERIC_REFERRAL_PAST_CLIENT_SENTINEL = "__pastClient";
export const GENERIC_REFERRAL_WORD_OR_MOUTH_SENTINEL = "__wordOfMouth";
export const GENERIC_REFERRAL_ADVERTISEMENT_SENTINEL = "__advertisement";
export const GENERIC_REFERRAL_EVENT_SENTINEL = "__event";
export const GENERIC_REFERRAL_INTERNET_SENTINEL = "__online";
export const DefaultReferences = [
    {
        key: EMPTY_REFERRAL_SENTINEL,
        text: "Unknown / Not Specified",
        group: "None",
    },
    {
        key: GENERIC_REFERRAL_ADVERTISEMENT_SENTINEL,
        text: "Advertisement",
        group: "General",
    },
    { key: GENERIC_REFERRAL_EVENT_SENTINEL, text: "Event", group: "General" },
    {
        key: GENERIC_REFERRAL_INTERNET_SENTINEL,
        text: "Online Search / Website",
        group: "General",
    },
    {
        key: GENERIC_REFERRAL_PAST_CLIENT_SENTINEL,
        text: "Past Client",
        group: "General",
    },
    {
        key: GENERIC_REFERRAL_WORD_OR_MOUTH_SENTINEL,
        text: "Word of Mouth",
        group: "General",
    },
];
export const COMMUNITY_REFERRAL = "__community";
//# sourceMappingURL=sentinels.js.map